module.exports = __webpack_public_path__ + "img/hr-tree-06-g-leaves.2b141799.png";